import styled from 'styled-components';

export const CustomCheckBox = styled.div<{ checked: boolean }>`
  height: 45px;
  width: 100px;
  background-color: ${p => p.checked ? '#96cdff': 'transparent'};
  color: ${p => p.checked ? '#329bfc': '#000'};
  outline: 2px solid #e6effb;
  outline-color: ${p => p.checked ? '#96cdff': '#e6effb'};
  margin-top: 20px;
  border-radius: 4px;
  flex: initial;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
  animation: 0.5s;
  cursor: pointer;
  user-select: none;
  &:hover {
    outline-color: #96cdff;
    outline-color: ${p => p.checked ? '#329bfc': '#96cdff'};
  }
`;
